import { useSettingsCollection } from "@store/Framework/Store/Context/ContextHooks";
import ForterFingerprint from "@store/Library/Components/Injectors/FraudProtection/ForterFingerprint";
import SignifydFingerprint from "@store/Library/Components/Injectors/FraudProtection/SignifydFingerprint";
import React, { FC } from "react";

const FraudProtectionFingerprint: FC = () => {
    const settings = useSettingsCollection();

    if (settings.extensionSignifydConnectorSettings?.enableConnector) {
        return <SignifydFingerprint />;
    }

    if (settings.extensionForterConnectorSettings?.enableConnector) {
        return <ForterFingerprint />;
    }

    return null;
};

export default FraudProtectionFingerprint;
